import Reflux from 'reflux';

export default Reflux.createActions({
  initialize: { sync: true },
  changeParams: { sync: true },
  changeInsuranceIssuer: {},
});
